import React, { Component } from 'react';
import { Icon, Modal } from 'antd';

interface IProps {
  content?: any;
  children?: React.ReactNode;
  width: any;
  style?: any;
  teksTitle: any;
  visible: any;
  onCancel?: any;
  className?: any;
  bodyStyle?: any;
  footer?: any;
}

export default class ModalCustomMaterial extends Component<IProps> {
  render() {
    return (
      <div>
        <Modal
          centered
          className={this.props.className}
          width={this.props.width}
          style={this.props.style}
          title={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                width: '100%',
                padding: 0
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  left: 0,
                  fontSize: 18,
                  color: '#11BEFF',
                  cursor: 'pointer',
                  display: 'flex'
                }}
                onClick={this.props.onCancel}
              >
                <Icon type="left" style={{ fontSize: 12, fontWeight: 'bolder' }} />
              </div>
              <div
                style={{ color: '#11BEFF', fontWeight: 'bold', fontSize: 16 }}
              >
                {this.props.teksTitle.toUpperCase()}
              </div>
            </div>
          }
          visible={this.props.visible}
          maskClosable={false}
          closable={false}
          footer={this.props.footer || null}
          bodyStyle={this.props.bodyStyle}
        >
          {this.props.children}
          {this.props.content}
        </Modal>
      </div>
    );
  }
}
